module.exports = "\n<ll-billing-activity client=\"vm.module.client\" />\n";